import React, { useState } from 'react';

function ButtonGroup({ onSelect }) {  // 接收来自父组件的 onSelect 回调函数
  const [selected, setSelected] = useState(null);

  const handleSelect = (number) => {
    setSelected(number);
    onSelect(number); // 调用父组件的回调函数，传递选中的按钮编号
  };

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      {[1, 2, 3, 4, 5].map((number) => (
        <button
          key={number}
          onClick={() => handleSelect(number)}
          className={selected === number ? 'selected-group' : 'button-group'}
          
        >
          {number}
        </button>
      ))}
    </div>
  );
}

export default ButtonGroup;
